import { call, take } from 'redux-saga/effects';

import { GET_VS_MARKERS } from './actions';
import { getMarkers } from 'services/learnkit';
import { markers as nmMarkers } from 'lib/normalizers';


function* getVsMarkers() {
  while (true) {
    yield take(GET_VS_MARKERS);

    const { markers } = yield call(getMarkers);
    yield nmMarkers(markers);
  }
}


export default getVsMarkers;
